export const FETCH_ALL_EXAMCODES = "[ADMIN] FETCH_ALL_EXAMCODES";
export const FETCH_ALL_EXAMCODES_SUCCESS = "[ADMIN] FETCH_ALL_EXAMCODESS_SUCCESS";
export const FETCH_ALL_EXAMCODES_ERROR = "[ADMIN] FETCH_ALL_EXAMCODES_ERROR";
export const FETCH_ALL_EXAMCODES_START = "[ADMIN] FETCH_ALL_EXAMCODES_START";
export const RESET_EXAMCODES = "[ADMIN] RESET_EXAMCODES";

export const ADD_UPDATE_EXAMCODE = "[ADMIN] ADD_UPDATE_EXAMCODE";
export const ADD_UPDATE_EXAMCODE_START = "[ADMIN] ADD_UPDATE_EXAMCODE_START";
export const ADD_UPDATE_EXAMCODE_SUCCESS = "[ADMIN] ADD_UPDATE_EXAMCODE_SUCCESS";
export const ADD_UPDATE_EXAMCODE_ERROR = "[ADMIN] ADD_UPDATE_EXAMCODE_ERROR";

export const SET_ALL_EXAMCODES_PAGINATION = '[ADMIN] SET_ALL_EXAMCODES_PAGINATION';


export const fetchAllExamCodes = (payload) => {
    return {
        type: FETCH_ALL_EXAMCODES,
        payload
    };
};

export const addUpdateExamCode = (examcode) => {
    return {
        type: ADD_UPDATE_EXAMCODE,
        payload: examcode
    }
}